import React from 'react'
import PageTitle from '../layouts/PageTitle'

export default function Confirmation () {
    return (
        <>
            <PageTitle step={3}/>

            <img src={'/wp-content/themes/vardekommune-website/assets/img/order-confirmed.png'} alt={'people celebrating'} />
        </>
    )
}
